import { httpClient } from '../../config';

export const fetchAffiliates = async (industryId) => {
  try {
    const query = industryId ? `?industry_id=${industryId}` : '';
    const { json } = await httpClient(`/tables/active_entities/get_active_entities${query}`);
    return json.affiliates;
  } catch (error) {
    console.error("Error fetching affiliates:", error);
    throw error;
  }
};
